export { default } from "./RecordingBarContainer";
